"use strict";
exports.__esModule = true;
exports.steps = exports.RECORD_STEP_DEFAULT = void 0;
exports.RECORD_STEP_DEFAULT = '1';
exports.steps = ['entry', 'cleansing', 'analysis'];
//# sourceMappingURL=record.js.map